export const CALENDAR_MODES = {
  SINGLE: 'single',
  RANGE: 'range',
} as const;

type CalendarModesKeys = keyof typeof CALENDAR_MODES;
export type CalendarMode = (typeof CALENDAR_MODES)[CalendarModesKeys];
